import { createContext } from 'react';

export interface RadioButtonProps {
  value: string;
  error?: boolean;
  disabled?: boolean;
  focus?: boolean;
  tabIndex?: number;
}

export interface RadioGroupContext {
  selectedValue?: string;
  onSelectValue: (value: string) => void;
  disabled?: boolean;
  error?: boolean;
  small?: boolean;
  vertical?: boolean;
}

export const radioGroupContext = createContext<RadioGroupContext | null>(null);
